import { useMutation, useQueryClient, type UseMutateFunction } from '@tanstack/react-query';
import { candidateService } from '../services/candidate.service';
import type { UpdateCandidateRequest, Candidate } from '../types/candidate.types';

interface UpdateCandidateParams {
  id: string;
  data: UpdateCandidateRequest;
}

export function useUpdateCandidate(): {
  updateCandidate: UseMutateFunction<Candidate, Error, UpdateCandidateParams>;
  updateCandidateAsync: (params: UpdateCandidateParams) => Promise<unknown>;
  isLoading: boolean;
  isError: boolean;
  isSuccess: boolean;
  error: Error | null;
  reset: () => void;
} {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ id, data }: UpdateCandidateParams) => candidateService.updateCandidate(id, data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['candidates'] });
      queryClient.invalidateQueries({ queryKey: ['candidate', variables.id] });
    },
  });

  return {
    updateCandidate: mutation.mutate,
    updateCandidateAsync: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
    reset: mutation.reset,
  };
}
